// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CurrencyRupeeIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CurrencyRupee/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 5a1 1 0 0 0 0 2h1a2 2 0 0 1 1.733 1H7a1 1 0 0 0 0 2h2.733A2 2 0 0 1 8 11H7a1 1 0 0 0-.707 1.707l3 3a1 1 0 0 0 1.414-1.414l-1.483-1.484A4.008 4.008 0 0 0 11.874 10H13a1 1 0 0 0 0-2h-1.126a3.973 3.973 0 0 0-.409-1H13a1 1 0 0 0 0-2H7Z",
  clipRule: "evenodd"
}));
export default CurrencyRupeeIcon;